/**
 * Server-pagination footer for the v2 tables: "第 1–100 台,共 344 台 · 伺服器分頁" + page size +
 * 上一頁 / 下一頁. The page owns page/limit state and re-queries the Worker.
 */
interface PagerProps {
  page: number;
  limit: number;
  total: number;
  unit: string; // 台 / 組 / 筆
  onPage: (page: number) => void;
  onLimit?: (limit: number) => void;
  limits?: number[];
  /** Optional prefix (e.g. 「近 7 日」) before the count. */
  prefix?: string;
}

export function Pager({ page, limit, total, unit, onPage, onLimit, limits = [50, 100, 200, 500], prefix }: PagerProps) {
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);
  const last = Math.max(1, Math.ceil(total / limit));
  return (
    <div className="pager">
      <span className="grow">
        {prefix ? `${prefix} ` : ''}第 {from}–{to} {unit},共 {total} {unit} · 伺服器分頁
      </span>
      {onLimit && (
        <label className="row" style={{ gap: 6 }}>
          每頁
          <select className="v2-select" value={limit} onChange={(e) => onLimit(Number(e.target.value))} aria-label="每頁筆數">
            {limits.map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>
      )}
      <button type="button" className="btn btn-outline" disabled={page <= 1} onClick={() => onPage(page - 1)}>上一頁</button>
      <button type="button" className="btn btn-outline" disabled={page >= last} onClick={() => onPage(page + 1)}>下一頁</button>
    </div>
  );
}
